import { AxiosResponse, AxiosInstance } from "axios";
export interface UpdateInstancePayload {
    description: string;
}

export function fetchLicensedInstances(
    axiosInstance: AxiosInstance
): Promise<AxiosResponse> {
    return axiosInstance.get(`/ctxr/-1/list?tenantId=1`);
}

export function fetchLicensedInstanceById(
    axiosInstance: AxiosInstance,
    instanceId: string
): Promise<AxiosResponse> {
    return axiosInstance.get(`/ctxr/-1/${instanceId}?tenantId=1`);
}

export function updateLicensedInstance(
    axiosInstance: AxiosInstance,
    instanceId: string,
    payload: UpdateInstancePayload
): Promise<AxiosResponse> {
    return axiosInstance.put(`/ctxr/-1/${instanceId}?tenantId=1`, payload);
}

export function deleteLicensedInstance(
    axiosInstance: AxiosInstance,
    instanceId: string
): Promise<AxiosResponse> {
    return axiosInstance.delete(`/ctxr/-1/RemoveLicense/${instanceId}?tenantId=1`);
}
